export default __webpack_public_path__ + "static/media/img_16.efeabed7.JPG";